import {Box, BoxProps, styled} from '@mui/material';

export const FullPageContainer = styled((props: BoxProps) => <Box {...props} />)(() => ({
  margin: `0 -16px`,
  width: `calc(100% + 32px)`,
}));
